__turbopack_context__.v({
  "promptContainer": "prompt-client-module__w-AGUG__promptContainer",
  "promptContent": "prompt-client-module__w-AGUG__promptContent",
});
